import { ChevronLeft, ChevronRight } from 'lucide-react';

const MESES = [
  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
];

const MESES_LARGOS = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

export function SelectorDeMes({
  valor,
  alCambiar,
  anio,
  alCambiarAnio,
  minimo,
  maximo,
  marcados = [],
  leyenda,
  accion = 'Elegir',
}: {
  valor: string;
  alCambiar: (periodo: string) => void;
  anio: number;
  alCambiarAnio: (anio: number) => void;

  minimo?: string;

  maximo?: string;

  marcados?: string[];

  leyenda?: string;

  accion?: string;
}) {
  const [anioElegido, mesElegido] = valor.split('-');

  return (
    <div className="overflow-hidden rounded-xl border border-armazon-200 bg-white">
      <div className="flex items-center justify-between border-b border-armazon-100 bg-armazon-50/60 px-3 py-2">
        <button
          type="button"
          onClick={() => alCambiarAnio(anio - 1)}
          aria-label="Año anterior"
          className="grid size-7 place-items-center rounded-lg text-armazon-500 transition-colors hover:bg-white hover:text-armazon-800"
        >
          <ChevronLeft className="size-4" aria-hidden />
        </button>

        <span className="importe text-sm font-semibold text-armazon-800">{anio}</span>

        <button
          type="button"
          onClick={() => alCambiarAnio(anio + 1)}
          aria-label="Año siguiente"
          className="grid size-7 place-items-center rounded-lg text-armazon-500 transition-colors hover:bg-white hover:text-armazon-800"
        >
          <ChevronRight className="size-4" aria-hidden />
        </button>
      </div>

      <div className="grid grid-cols-4 gap-1.5 p-3">
        {MESES.map((nombre, i) => {
          const periodo = `${anio}-${String(i + 1).padStart(2, '0')}`;
          const elegido = periodo === valor;
          const marcado = marcados.includes(periodo);
          const fuera = (minimo && periodo < minimo) || (maximo && periodo > maximo);

          return (
            <button
              key={periodo}
              type="button"
              onClick={() => alCambiar(periodo)}
              disabled={Boolean(fuera)}
              title={
                fuera
                  ? 'No se puede elegir'
                  : `${accion} ${MESES_LARGOS[i]} de ${anio}`
              }
              className={`relative rounded-lg py-2 text-xs font-semibold uppercase transition-colors ${
                elegido
                  ? 'bg-marca-600 text-white'
                  : fuera
                    ? 'cursor-not-allowed text-armazon-300'
                    : 'text-armazon-700 hover:bg-armazon-100'
              }`}
            >
              {nombre}
              {marcado && (
                <span
                  aria-hidden
                  className={`absolute inset-x-0 bottom-1 mx-auto size-1 rounded-full ${
                    elegido ? 'bg-white/70' : 'bg-emerald-500'
                  }`}
                />
              )}
            </button>
          );
        })}
      </div>

      <p className="border-t border-armazon-100 bg-armazon-50/60 px-3 py-2 text-[11px] uppercase text-armazon-500">
        {accion}{' '}
        <span className="font-semibold text-armazon-700">
          {MESES_LARGOS[Number(mesElegido) - 1]} de {anioElegido}
        </span>
        {leyenda && marcados.length > 0 && (
          <span className="ml-2 inline-flex items-center gap-1">
            <span className="size-1 rounded-full bg-emerald-500" aria-hidden />
            {leyenda}
          </span>
        )}
      </p>
    </div>
  );
}

export function mesAnterior(fecha: Date = new Date()): string {
  const anterior = new Date(fecha.getFullYear(), fecha.getMonth() - 1, 1);
  return `${anterior.getFullYear()}-${String(anterior.getMonth() + 1).padStart(2, '0')}`;
}

/** «2026-09» → «septiembre de 2026». Lo que no tenga esa forma se devuelve tal cual. */
export function nombreDelMes(periodo: string): string {
  const partes = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(periodo);
  return partes ? `${MESES_LARGOS[Number(partes[2]) - 1]} de ${partes[1]}` : periodo;
}

export function mesDe(fecha: Date = new Date()): string {
  return `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}`;
}
